import { CategoryContent } from './category_content-model';
import { TabCategory } from './tab_category.model';
import { MPCode } from './MPCode.model';
import { ToolTypes } from './ToolTypes.model';
import { PDFTemplate } from './PDFTemplate.model';
import { LocalProductRef, ProductLimits } from './product-limits.model';

/**
 * Everything needed to put the configurator back exactly as the user left it.
 *
 * Two sources are merged here: the shared state in ProductTabsService, and the
 * slice that only lives on NavbarComponent (sliders, rule-derived bounds, the
 * per-category tool-type picks) which is mirrored into ConfiguratorStateService
 * because the navbar is destroyed before a configuration reaches the cart.
 *
 * Bump `version` if the shape changes; restore checks it so an old cart item
 * fails loudly rather than restoring half a configuration.
 */
export const CONFIGURATION_SNAPSHOT_VERSION = 1;

export interface ConfigurationSnapshot {
  version: number;

  finalProductId: number;
  line: string | null;
  entryCategoryId: number | null;

  /* --- ProductTabsService --- */
  selected: { Content: CategoryContent, Category: TabCategory }[];
  materialValues: { Name: string, Value: string, card_place_id: number, id: number }[];
  productLimits: ProductLimits[];
  localProducts: LocalProductRef[];
  mpCode: MPCode;
  additionalFields: { type: string, value: any, label?: string }[];
  selectedToolTypes: ToolTypes[];
  backgroundId: number | null;
  backgroundColor: string;

  /* --- NavbarComponent, via ConfiguratorStateService --- */
  rawMaterialValues: { [key: string]: number };
  affectedMaterialValues: {
    [key: number]: {
      min: number;
      max: number;
      categories: number[];
      affectedByRule: boolean;
      affectedByRuleId: number | null;
    };
  };
  materialLimits: { [key: number]: { min: number, max: number, categories: number[] } };
  aggregatedMaterialValues: {
    [key: number]: { Name: string, Value: string, card_place_id: number, id: number };
  };
  selectedToolTypesByCategory: { [categoryId: number]: ToolTypes };
  selectedTabIndex: number;

  /* --- PDFService --- */
  selectedTemplates: PDFTemplate[];
  textFieldData: any;
}
